import { useState } from "react";
import "../../css/UserEditModal.css";
import "../../css/SiteAdminModals.css";

interface AddNoteModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (content: string) => void;
}

export const AddNoteModal = ({ isOpen, onClose, onSave }: AddNoteModalProps) => {
    const [content, setContent] = useState("");

    if (!isOpen) return null;

    const handleClose = () => { setContent(""); onClose(); };
    const handleSave = () => {
        if (!content.trim()) return;
        onSave(content.trim());
        setContent("");
    };

    return (
        <div className="uem-overlay" onClick={handleClose}>
            <div className="uem-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
                <div className="uem-header">
                    <h2>Add Note</h2>
                    <button className="uem-close" onClick={handleClose} aria-label="Close">×</button>
                </div>
                <div className="uem-body">
                    <div className="uem-field">
                        <label>Note</label>
                        <textarea
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            placeholder="Enter your note here..."
                            style={{ width: "100%", minHeight: 120, padding: "10px 14px", border: "1px solid #d5dbe0", borderRadius: 8, fontSize: "0.9rem", color: "var(--navy-blue)", fontFamily: "inherit", resize: "vertical", boxSizing: "border-box", background: "var(--white)" }}
                        />
                    </div>
                    <p className="uem-date-hint">Date and your name will be recorded automatically.</p>
                </div>
                <div className="uem-footer">
                    <button type="button" className="uem-btn-cancel" onClick={handleClose}>Cancel</button>
                    <button type="button" className="uem-btn-submit" disabled={!content.trim()} onClick={handleSave}>Save Note</button>
                </div>
            </div>
        </div>
    );
};
